import { useState, useEffect, useCallback } from 'react';
import { parseBackendDate } from '../utils/formatters';

export const useGradeSemanal = (user, createApi, dataReferencia) => {
  const [grade, setGrade] = useState(null);
  const [periodo, setPeriodo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Função para ordenar vagas consistentemente
  const ordenarVagas = useCallback((vagas) => {
    if (!vagas || !Array.isArray(vagas)) return vagas;
    return [...vagas].sort((a, b) => {
      const dataA = parseBackendDate(a.data_hora);
      const dataB = parseBackendDate(b.data_hora);
      if (dataA && dataB) {
        const diff = dataA.getTime() - dataB.getTime();
        if (diff !== 0) return diff;
      }
      return (parseInt(a.id) || 0) - (parseInt(b.id) || 0);
    });
  }, []);

  const loadGrade = useCallback(async () => {
    if (!user) return;
    setLoading(true);
    setError('');
    try {
      const api = createApi();
      const params = dataReferencia ? { data_referencia: dataReferencia } : {};
      const response = await api.get('/grade-semanal', { params });
      
      // Ordenar as vagas antes de armazenar
      const gradeOrdenada = ordenarVagas(response.data.grade);
      
      const periodoCorrigido = response.data.periodo ? {
        ...response.data.periodo,
        inicio: new Date(response.data.periodo.inicio),
        fim: new Date(response.data.periodo.fim),
        data_referencia: response.data.periodo.data_referencia ? new Date(response.data.periodo.data_referencia) : null
      } : null;
      
      setGrade(gradeOrdenada);
      setPeriodo(periodoCorrigido);
    } catch (err) {
      console.error('Erro completo ao carregar grade:', err);
      const message = err.response?.data?.error || err.message || 'Erro ao carregar grade';
      setError(message);
    } finally {
      setLoading(false);
    }
  }, [user, createApi, dataReferencia, ordenarVagas]);

  useEffect(() => {
    loadGrade();
  }, [loadGrade]);

  return { grade, periodo, loading, error, refetch: loadGrade };
};
